// extracted by mini-css-extract-plugin
export default {"createBtn":"accountStyle_createBtn__SDt2t","searchInput":"accountStyle_searchInput__LRk1W"};